<template>
    <div class="try-it-out-page">
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="header-banner banner-try">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col">
                            <img src="~img/hedear-isbandyti.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div class="main">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="content-box">
                            <div class="content-header">
                                <h1 class="content-title">Išbandykite <br>nemokamai</h1>
                                <span class="content-subtitle">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto dubliavimo: „Tekstas tekstas tekstas tekstas...“</span>
                            </div>
                            <!-- Form -->
                            <div class="form-wrapper">
                                <div class="form-container bg-white">
                                    <div class="form-container-header">
                                        <div class="form-title">
                                            <div class="form-title-title">Asmeninio pasiūlymo sudarymas</div>
                                            <ul class="pagination-nav">
                                                <li class="active"><a href="#">1</a></li>
                                                <li><a href="#">2</a></li>
                                                <li><a href="#">3</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="form-container-body mb-5">
                                        <div class="row justify-content-between">
                                            <div class="col-12 col-sm-6">
                                                <div class="range-container">
                                                    <div class="range-container-title">Kokį SKU kiekį planuojate <br>sandėliuoti?</div>
                                                    <div class="range-container-output">51-250</div>
                                                    <input type="range" class="custom-range" id="typeSKU">
                                                    <div class="range-container-description">SKU - Yra daug įvarių Lorem Ipsum variantų, bet daugelis
                                                    jų buvo vienokiu ar kitokiu būdu modifikuoti
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <div class="range-container">
                                                    <div class="range-container-title">Apytikslus mėnesio <br>užsakymų kiekis</div>
                                                    <div class="range-container-output">250-10000</div>
                                                    <input type="range" class="custom-range" id="monthly-orders">
                                                    <div class="range-container-description">Lorem Ipsum variantų, bet daugelis jų buvo vienokiu ar
                                                    kitokiu būdu modifikuoti
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-container-footer">
                                        <a href="#" class="btn btn-link">pagalba</a>
                                        <button type="button" class="btn btn-secondary">Toliau</button>
                                    </div>
                                </div>

                                <div class="form-container bg-white">
                                    <div class="form-container-header">
                                        <div class="form-title">
                                            <div class="form-title-title">Kontaktinė informacija</div>
                                            <ul class="pagination-nav">
                                                <li class="active"><a href="#">1</a></li>
                                                <li><a href="#">2</a></li>
                                                <li><a href="#">3</a></li>
                                            </ul>
                                        </div>
                                        <div class="button-wrapper row">
                                            <div class="col-12 col-sm-6">
                                                <button type="button" class="btn btn-facebook"><i class="icon-facebook-sign"></i> registruotis su
                                                    facebook
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-container-body">
                                        <div class="form-container-body-title">
                                            <span class="bg-white">arba</span>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" placeholder="Petra|">
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" placeholder="Pavardė">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" placeholder="Telefono numeris">
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-6">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" placeholder="El. pašto adresas">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-container-footer">
                                        <a href="#" class="btn btn-link">pagalba</a>
                                        <div class="button-wrapper">
                                            <a href="#" class="btn btn-link">atgal</a>
                                            <button type="button" class="btn btn-secondary">Toliau</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-container bg-white">
                                    <div class="form-container-header pt-90">
                                        <div class="form-title pb-50">
                                            <div class="form-title-title">Įmonės informacija</div>
                                            <ul class="pagination-nav">
                                                <li class="active"><a href="#">1</a></li>
                                                <li class="active"><a href="#">2</a></li>
                                                <li class="active"><a href="#">3</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="form-container-body">

                                        <!-- Form Group -->
                                        <div class="form-group-wrapper">
                                            <div class="form-row">
                                                <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Įmonės pavadinimas">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Įmonės kodas">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="PVM mokėtojo kodas">
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Adresas">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="Internetinio tinklalapio adresas">
                                            </div>
                                            <hr>
                                            <div class="form-group input-pseudoselect">
                                                <input type="text" class="form-control" placeholder="Kaip sužinojote apie Boxiti?">
                                            </div>
                                        </div><!-- End Form Group -->

                                    </div>
                                    <div class="form-container-footer">
                                        <a href="#" class="btn btn-link">pagalba</a>
                                        <div class="button-wrapper">
                                            <a href="#" class="btn btn-link">atgal</a>
                                            <button type="button" class="btn btn-accent">Registruotis nemokamam išbandymui</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'TryItOut'
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/TryItOut.vue